<template>

  <!-- 属性模块 -->
  <div class="parts" id="PARTS-SWF">

    <div class="mask" v-show="mask_visible"></div>

    <div class="inner">
      <ul class="l1 clearfix"></ul>
      <div class="title">部件状态</div>
      <ul class="l2 clearfix"></ul>

    </div>

  </div>

</template>

<script>

  // 通讯协议
  import Protocol from '@/common/scripts/protocol.js'

  import bindingIconUrl from './binding.png'

  export default {
    // 组件
    components: {
    },
    // 计算
    computed: {

    },
    data () {
      return {
        platform: this.$route.query.platform,
        imgBase64: '',
        L1: [],
        L2: [],
        css_sprites: {},
        init: '',
        mask_visible: true,

        pgridW: 36,
        //cgridW: 30,
        picW: 32,
        picH: 32,
        bindingIconUrl: bindingIconUrl,
        // -------------------------------------------------- [ FLASH ] --------------------------------------------------


      }
    },
    methods: {
      handleList1 (index, data, item) {

        let platform = this.$route.query.platform

        let parts_scene_7_40 = {
          packageId: 0,
          senderId: PARTS,
          senderName: PARTS_NAME,
          receiverId: SCENE,
          receiverName: SCENE_NAME,
          timeFlag: new Date().getTime(),
          sessionId: 7,
          messageId: 40,
          protoBytesType: 'proto.com.proto.s.MString',
          protoBytes: Protocol.serializeBinary(new proto.com.proto.s.MString(), {
            setValue: item[0]
          })
        }

        // 发送消息
        Protocol.sender(platform, parts_scene_7_40)

        this.changeTab(index, data)

      },
      handleList2 (index, data, item) {

        let platform = this.$route.query.platform

        let parts_scene_7_41 = {
          packageId: 0,
          senderId: PARTS,
          senderName: PARTS_NAME,
          receiverId: SCENE,
          receiverName: SCENE_NAME,
          timeFlag: new Date().getTime(),
          sessionId: 7,
          messageId: 41,
          protoBytesType: 'proto.com.proto.s.MString',
          protoBytes: Protocol.serializeBinary(new proto.com.proto.s.MString(), {
            setValue: item[0]
          })
        }

        // 发送消息
        Protocol.sender(platform, parts_scene_7_41)

        this.changeTab(index, data)

      },
      changeTab(index, data) {

        for (let i = 0; i < data.length; i++) {

          data[i].active = false

        }

        data[index].active = true

      },
    },
    mounted () {
        console.log("Parts mounted")
        let platform = this.$route.query.platform
        let _this = this;
        // PARTS
        // 模块初始化
        Protocol.onSocketInit(platform, PARTS_NAME, PARTS)
        // 模块与服务器建立链接
        Protocol.onSocketConnect(platform, PARTS_NAME)
        // 模块与服务器建立链接
        Protocol.onSocketRegister(platform, PARTS_NAME, PARTS)

        window[PARTS_NAME].domReady = () => {
            let actioninfo_scene_6_26 = {
                packageId: 0,
                senderId: ACTIONINFO,
                senderName: ACTIONINFO_NAME,
                receiverId: SCENE,
                receiverName: SCENE_NAME,
                timeFlag: new Date().getTime(),
                sessionId: 6,
                messageId: 26,
                protoBytesType: '',
                protoBytes: []
            }
            // 发送消息
            Protocol.sender(platform, actioninfo_scene_6_26)
        }

      // 接收消息
      Protocol.receiver(platform, PARTS_NAME)

      window[PARTS_NAME].message = function (senderId, packageId, sessionId, messageId, protoBytes) {
          if(sessionId == 1 && messageId == 12) {
              let arr = Protocol.deserializeBinary('proto.com.proto.s.MTabData', protoBytes).array
              let tab_type = arr[0]
              if(tab_type == 2) { //动作编辑器里清理部件列表
                  _this.L1 = []
                  _this.L2 = []
                  let list = document.querySelector('.l1')
                  if(list) list.innerHTML = ''
              }
          }
          if (sessionId == 6 && messageId == 5) {
            _this.init = 'complete'

            _this.mask_visible = false
            console.log('[' + PARTS_NAME + '][COMPLETE]')

          }

        if (sessionId == 7 && messageId == 14) {

          _this.mask_visible = false

          let arr = Protocol.deserializeBinary('proto.com.proto.actioneditortimeline.MBundlePartsInfo', protoBytes).array
          console.log('7_14', arr)
          _this.L1 = arr[1]

          //部件列表变更意味着形象上下文切换：清空子部件状态区，等7_15重建（防止残留上一形象的格子）
          _this.L2 = []
          let list2 = document.querySelector('.l2')
          if (list2) list2.innerHTML = ''

          let list = document.querySelector('.l1')

          list.innerHTML = ''

          let pgridW = 36;

          let picW = 32

          let picH = 32

          let offsetX = ( pgridW - picW ) / 2

          let offsetY = ( pgridW - picH ) / 2

          for (let i = 0; i < _this.L1.length; i++) {
            let mPartInfo = _this.L1[i]
            //let imgBase64 = 'url(data:image/png;base64,' + _arrayBufferToBase64(mPartInfo[5]) + ')'
            let imgBase64 = 'data:image/png;base64,' + _arrayBufferToBase64(mPartInfo[5])
            let li = document.createElement('li')
            let picBkg = document.createElement('div')
            let pic = document.createElement('img')
            let bindingIcon = document.createElement('img')
            let name = document.createElement('div')

            li.style.float = 'left'
            li.style.width = '37px'
            li.style.margin = '3.7px'
            li.style.background = '#fff'
            li.style.border = '1px solid #e8e8e8'
            li.style.boxSizing = 'border-box'
            li.style.cursor = 'pointer'
            li.dataset.id = mPartInfo[0]

            name.className = 'name'
            name.style.display = 'block';
            name.style.width = '35px';
            name.style.height = '30px';
            name.style.lineHeight = '15px'
            name.style.overflow = 'hidden'
            name.style.textAlign = 'center'
            name.style.padding = '2px 0'
            name.style.fontSize = '12px'
            name.style.webkitTransform = 'scale(0.8)'
            name.innerHTML = undefined == _this.L1[i][1] ? '' : mPartInfo[1]

            picBkg.className = 'picBkg';
            picBkg.style.width = pgridW + 'px'
            picBkg.style.height = pgridW + 'px'
            picBkg.style.position = 'relative'

            pic.src = imgBase64;
            pic.className = 'pic'
            pic.style.float = 'left'
            pic.style.width = picW + 'px'
            pic.style.height = picH + 'px'
            pic.style.marginLeft = offsetX + 'px'
            pic.style.marginTop = offsetY + 'px'

            if(mPartInfo[4] == "HOLDBUNDLE"){
              bindingIcon.src = bindingIconUrl
              bindingIcon.className = 'bindingIcon'
              bindingIcon.style.width = '15px'
              bindingIcon.style.height = '14px'
              bindingIcon.style.position = 'absolute'
              bindingIcon.style.top = '0px'
              bindingIcon.style.right = '0px'
              //bindingIcon.style.float = 'left'
            }

            picBkg.appendChild(pic)
            if(mPartInfo[4] == "HOLDBUNDLE"){
              picBkg.appendChild(bindingIcon)
            }
            li.appendChild(picBkg)
            li.appendChild(name)
            list.appendChild(li)

          }

          $('.l1 > li').each(function(i) {

            let id = $(this).data('id')
            $(this).on('click', function() {

              $(this).css('border', '1px solid #f00')
                     .siblings().css('border', '1px solid #e8e8e8')
              let parts_scene_7_40 = {
                packageId: 0,
                senderId: PARTS,
                senderName: PARTS_NAME,
                receiverId: SCENE,
                receiverName: SCENE_NAME,
                timeFlag: new Date().getTime(),
                sessionId: 7,
                messageId: 40,
                protoBytesType: 'proto.com.proto.s.MString',
                protoBytes: Protocol.serializeBinary(new proto.com.proto.s.MString(), {
                  setValue: id
                })
              }

              // 发送消息
              Protocol.sender(platform, parts_scene_7_40)

            })

          })

        }

        if (sessionId == 7 && messageId == 15) {
          let arr = Protocol.deserializeBinary('proto.com.proto.actioneditortimeline.MSelectPartInfo', protoBytes).array
          console.log('7_15start', arr)

          _this.L2 = arr[1]

          let mPartInfo = arr[0]
          //console.log('7_15mPartInfo', mPartInfo)
          let list = document.querySelector('.l2')

          list.innerHTML = ''
          //只有部件才会显示贴图
          if (mPartInfo != undefined && mPartInfo[4] == "PART") {
            let pgridW = 36;

            let picW = 32

            let picH = 32

            let offsetX = ( pgridW - picW ) / 2

            let offsetY = ( pgridW - picH ) / 2

            for (let i = 0; i < _this.L2.length; i++) {
              let mCellInfo = _this.L2[i]
              let imgBase64 = 'data:image/png;base64,' + _arrayBufferToBase64(mCellInfo[2])
              let li = document.createElement('li')
              let picBkg = document.createElement('div')
              let pic = document.createElement('img')
              let name = document.createElement('div')

              li.style.float = 'left'
              li.style.width = '37px'
              li.style.margin = '3.7px'
              li.style.background = '#fff'
              li.style.border = '1px solid #e8e8e8'
              li.style.boxSizing = 'border-box'
              li.style.cursor = 'pointer'
              li.dataset.id = mCellInfo[0]

              name.className = 'name'
              name.style.display = 'block';
              name.style.width = '35px';
              name.style.height = '30px';
              name.style.lineHeight = '15px'
              name.style.overflow = 'hidden'
              name.style.textAlign = 'center'
              name.style.padding = '2px 0'
              name.style.fontSize = '12px'
              name.style.webkitTransform = 'scale(0.8)'
              name.innerHTML = mCellInfo[1]

              picBkg.className = 'picBkg';
              picBkg.style.width = pgridW + 'px'
              picBkg.style.height = pgridW + 'px'

              pic.src = imgBase64
              pic.className = 'pic'
              pic.style.float = 'left'
              pic.style.width = picW + 'px'
              pic.style.height = picH + 'px'
              pic.style.marginLeft = offsetX + 'px'
              pic.style.marginTop = offsetY + 'px'

              picBkg.appendChild(pic)
              li.appendChild(picBkg)
              li.appendChild(name)
              list.appendChild(li)

            }

          }

          $('.l1 > li').each(function(i) {

            let id = $(this).data('id');

            if (id == mPartInfo[0]) {
              $(this).css('border', '1px solid #f00')
            } else {
              //console.log("id=" + id)
              $(this).css('border', '1px solid #e8e8e8')
            }
          })

          $('.l2 > li').each(function(i) {
            let id = $(this).data('id')

            if (id == mPartInfo[3]) {
              $(this).css('border', '1px solid #f00')
            }

            $(this).on('click', function() {

              $(this).css('border', '1px solid #f00')
              $(this).siblings().css('border', '1px solid #e8e8e8')

              let parts_scene_7_41 = {
                packageId: 0,
                senderId: PARTS,
                senderName: PARTS_NAME,
                receiverId: SCENE,
                receiverName: SCENE_NAME,
                timeFlag: new Date().getTime(),
                sessionId: 7,
                messageId: 41,
                protoBytesType: 'proto.com.proto.s.MString',
                protoBytes: Protocol.serializeBinary(new proto.com.proto.s.MString(), {
                  setValue: id
                })
              }

              // 发送消息
              Protocol.sender(platform, parts_scene_7_41)

            })

          })

          console.log('7_15end')
        }

        // 锁定模块
        if (sessionId == 1 && messageId == 13){
            _this.mask_visible = true
        }
        // 解除锁定
        if (sessionId == 1 && messageId == 14){
          _this.mask_visible = false
        }

      }

    }
  }

  function _arrayBufferToBase64( buffer ) {
    var binary = ''
    var bytes = new Uint8Array(buffer)
    var len = bytes.byteLength
    for (var i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i])
    }
    return window.btoa(binary)
  }
</script>

<style lang="stylus" scoped>
  .parts
    background: #505050//#e8e8e8
    position: absolute
    top: 0
    right: 0
    bottom: 0
    left: 0
    .mask
      position: absolute
      top: 0
      right: 0
      bottom: 0
      left: 0
      width: 280px
      background: #3a3a3a//rgba(255, 255, 255,.8)
      z-index: 1
    .inner
      position: absolute
      top: 0
      right: 8px
      bottom: 0
      left: 0
      overflow: auto
    .title
      padding: 10px 10px 5px 10px
      color:#e2e2e2
    .l1
      padding: 5px 0 0 5px
      .item
        .name
            line-height 15px
            display block
            height 35px
            width 35px
            overflow hidden
            text-align: center
            font-size: 12px
            -webkit-transform: scale(0.8)
            padding: 2px 0
    .l2
      padding: 5px 0 0 5px
      .item
        float: left
        width: 37px
        margin: 10px
        background: green//#fff
        margin: 5px
        border: 1px solid #e8e8e8
        box-sizing: border-box
        cursor: pointer
        .pic
          width: 35px
          height: 35px
          float: left
          .inner
            background-repeat: no-repeat
            background-size: 100%
            float: left
        .name
          line-height 15px
          display block
          height 35px
          overflow hidden
          text-align: center
          font-size: 12px
          -webkit-transform: scale(0.8)
          padding: 2px 0
      .active
        border: 1px solid #f00

</style>



// WEBPACK FOOTER //
// Parts.vue?c00d1048